<div class="ct-container">

  <div class="ct-header">
    <h2 class="ct-title">Active Client Tier Alignment</h2>
  </div>

  <!-- Upload section -->
  <div class="ct-card">
    <h3 class="ct-card-title">Upload Charity Commission File</h3>
    <p class="ct-card-subtitle">
      Only active clients (those with a current subscription and no end date) are shown below.
      Select the <em>publicextract.charity_annual_return_partb.txt</em> tab-separated file.
      Required columns: <code>registered_charity_number</code> and <code>income_legacies</code>.
    </p>
    <div class="upload-row">
      <label class="upload-btn">
        <mat-icon>upload_file</mat-icon>
        Choose File
        <input type="file" accept=".txt,.csv" (change)="onFileSelected($event)" style="display:none">
      </label>
      <span class="file-name" *ngIf="fileName">{{ fileName }}</span>
      <span class="file-name placeholder" *ngIf="!fileName">No file selected</span>
    </div>
  </div>

  <div *ngIf="loading" class="loading-msg">Loading client data&hellip;</div>

  <!-- Results -->
  <div *ngIf="fileUploaded && !loading">

    <!-- Summary strip -->
    <div class="summary-strip">
      <div class="summary-pill pill-matched">
        <span class="pill-num">{{ matchedRows.length }}</span>
        <span class="pill-lbl">Matched</span>
      </div>
      <div class="summary-pill pill-mismatch">
        <span class="pill-num">{{ mismatchCount }}</span>
        <span class="pill-lbl">Tier Mismatch</span>
      </div>
      <div class="summary-pill pill-unmatched">
        <span class="pill-num">{{ unmatchedRows.length }}</span>
        <span class="pill-lbl">Not in File</span>
      </div>
      <div class="summary-actions">
        <button mat-raised-button class="apply-btn" *ngIf="mismatchCount > 0" (click)="applyAllSuggested()">
          Apply All Suggested
        </button>
        <button mat-button class="clear-btn" *ngIf="changedCount > 0" (click)="clearAll()">
          Clear All
        </button>
      </div>
    </div>

    <!-- Matched clients -->
    <div class="ct-section" *ngIf="matchedRows.length">
      <h3 class="ct-section-title">Matched Active Clients ({{ matchedRows.length }})</h3>
      <table class="ct-table">
        <thead>
          <tr>
            <th>Client Name</th>
            <th>Charity No.</th>
            <th class="num-col">Avg App Income</th>
            <th class="num-col">Avg Legacy Income</th>
            <th>Current Tier</th>
            <th>Suggested Tier</th>
            <th class="action-col">New Tier</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of matchedRows" [class.row-mismatch]="row.tierMismatch">
            <td>{{ row.clientName }}</td>
            <td class="mono">{{ row.beneficiarySourceUrn }}</td>
            <td class="num-col">{{ row.avgAppIncome !== null ? (row.avgAppIncome | number:'1.0-0') : '—' }}</td>
            <td class="num-col">{{ row.income | number:'1.0-0' }}</td>
            <td>{{ row.currentTierName ?? '—' }}</td>
            <td [class.tier-mismatch-cell]="row.tierMismatch">{{ row.suggestedTierName ?? '—' }}</td>
            <td class="action-col">
              <select class="tier-select" [(ngModel)]="row.selectedTierId">
                <option [ngValue]="null">— Keep Current —</option>
                <option *ngFor="let tier of activeTiers" [ngValue]="tier.id">{{ tier.name }}</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Unmatched clients -->
    <div class="ct-section" *ngIf="unmatchedRows.length">
      <h3 class="ct-section-title">Active Clients Not in File ({{ unmatchedRows.length }})</h3>
      <p class="ct-section-note">
        These clients have no matching charity number in the uploaded file — they may be non-charities.
        Avg App Income is calculated from their bequest history in the app instead. Review manually and
        select a new tier if required.
      </p>
      <table class="ct-table">
        <thead>
          <tr>
            <th>Client Name</th>
            <th class="num-col">Avg App Income</th>
            <th>Current Tier</th>
            <th class="action-col">New Tier</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of unmatchedRows">
            <td>{{ row.clientName }}</td>
            <td class="num-col">{{ row.avgAppIncome !== null ? (row.avgAppIncome | number:'1.0-0') : '—' }}</td>
            <td>{{ row.currentTierName ?? '—' }}</td>
            <td class="action-col">
              <select class="tier-select" [(ngModel)]="row.selectedTierId">
                <option [ngValue]="null">— Keep Current —</option>
                <option *ngFor="let tier of activeTiers" [ngValue]="tier.id">{{ tier.name }}</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Save bar -->
    <div class="save-bar">
      <span class="change-count" *ngIf="changedCount > 0">{{ changedCount }} change(s) pending</span>
      <button mat-raised-button class="save-btn"
              [disabled]="saving || changedCount === 0"
              (click)="saveChanges()">
        <mat-icon>save</mat-icon> {{ saving ? 'Saving…' : 'Save Changes' }}
      </button>
    </div>

  </div>

</div>
